export const ROWS_INFO_MAX_LENGTH = 50;
export const EMAIL_ALERT_SRC_SHORTNAME = 'email';
